<template>
  <v-tooltip top>
    <template v-slot:activator="{ on, attrs }">
      <!-- display: block -->
      <span v-on="on" v-bind="attrs" @click.stop="onClick">
        <v-badge
          dot
          overlap
          :color="hasAlert ? 'error' : 'warning'"
          :value="hasAlert || hasWarning"
        >
          <v-icon small left color="secondary">{{ recTypeIcon }}</v-icon>
        </v-badge>
        <!-- TODO create space between icon and text with other method than spaces -->
        {{ '  ' + signature }}
      </span> </template
    ><span>{{ iri.prefixed }}</span>
  </v-tooltip>
</template>

<script>
// TODO if individual cannot be read show the Iri
// during initila sync it will not be klnown if its a named individuals or ifg it hasent been resolved yet!!!
// TODO Make the type bold/secondary color or something to amke the link stand out, potentially use the icon for type too.

import { Iri } from '@/rec-cache/rec-cache-types'

import { RecIndividual } from '@/rec-cache/rec-cache-individual'

import { recIcon } from '@/vue-wob-cache/vue-wob-icons'

export default {
  // components: { HighlightedText },
  props: {
    iri: {
      type: Object,
      default: () => {
        return new Iri()
      },
    },
    link: {
      type: Boolean,
      default: () => {
        return true
      },
    },
  },
  data: () => ({
    individual: new RecIndividual(),
    linkable: false,
    signature: 'Pending',
    type: null,
    label: null,
  }),
  computed: {
    recTypeIcon: function () {
      return recIcon(this.individual.type)
    },
    hasAlert: function () {
      const id = this.individual.id.value
      return (
        this.$wob.openExceptions.ids.map((id) => id.value).includes(id) ||
        this.$wob.activeAlarms.ids.map((id) => id.value).includes(id) ||
        this.$wob.alarmingAssets.ids.map((id) => id.value).includes(id)
      )
    },
    hasWarning: function () {
      return this.$wob.impactedAssets.ids
        .map((id) => id.value)
        .includes(this.individual.id.value)
    },

    // TODO remove after testing...
    // hasException: function () {
    //   return (
    //     this.$wob.impacts.ids.includes(this.iri.value) ||
    //     this.$wob.exceptions.ids.includes(this.iri.value)
    //   )
    // },
  },
  mounted: function () {
    // console.log('components.individual-signature.mounted', this.iri)
    this.linkable = false
    if (this.$wob.isIndividual(this.iri)) {
      this.signature = this.iri.short
      return
    }
    const individual = this.$wob.read(this.iri)
    if (individual) {
      this.linkable = true
      this.type = individual.type.short
      this.label = individual.label.value
      this.signature = this.label
        ? `${this.type} | ${this.label}`
        : `${this.type}`
      this.individual = individual
      return
    }
    this.signature = `Not resolvable`
  },
  methods: {
    onClick: function () {
      console.log('components.individual-signature.on-click', this.link)
      if (this.link && this.linkable)
        this.$router.push(`/individual/${encodeURIComponent(this.iri.value)}`)
    },
  },
}
</script>
